import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import ErrorPage from "./ErrorPage";
import { errorTypes } from "./ErrorTypes";

type Props = {
  intl: intlShape;
};

export function NotFound({ intl }: Props) {
  return (
    <ErrorPage
      header={intl.formatMessage({ id: "not_found.header" })}
      details={intl.formatMessage({ id: "not_found.details" })}
      errorType={errorTypes.not_found}
    />
  );
}

export default injectIntl(NotFound);
